module.exports = __webpack_public_path__ + "static/media/005.50720c84.jpg";